import { Action, createAction } from 'redux-act';

import PlaceProfile from '../../../models/interfaces/PlaceProfile';
import TimestampPayload from '../TimestampPayload';

export interface SaveProfilePayload extends TimestampPayload {
  profile: PlaceProfile;
}
export const saveProfile = createAction<SaveProfilePayload>('SAVE_PROFILE');
export type SaveProfileActionType = Action<SaveProfilePayload>;
export interface ProfileSavedPayload extends TimestampPayload {
  profile: PlaceProfile;
}
export const profileSaved = createAction<ProfileSavedPayload>('PROFILE_SAVED');
export interface ProfileSaveFailedPayload extends TimestampPayload {
  placeUuid: string;
  profileUuid: string;
}
export const profileSaveFailed = createAction<ProfileSaveFailedPayload>('PROFILE_SAVE_FAILED');
